import {
  LLM_NO_SPEECH_DETECTED_SENTINEL,
  NO_SPEECH_DETECTED_TRANSCRIPT_MESSAGE,
} from '@act/shared/constants';
import { transcriptFormatter } from 'utilities/formatters/transcriptFormatter';

export const NO_TRANSCRIPTION_MESSAGE = 'No transcription was found.';

export { NO_SPEECH_DETECTED_TRANSCRIPT_MESSAGE };

/** Garbled artifact from legacy transcript splitting of raw LLM no-speech sentinel. */
const LEGACY_NO_SPEECH_GARBLED = '[NO_SPEECH_DETECTED';

export function isNoSpeechTranscriptText(value: string): boolean {
  const v = value.trim();
  return (
    v === NO_SPEECH_DETECTED_TRANSCRIPT_MESSAGE ||
    v.toUpperCase() === LLM_NO_SPEECH_DETECTED_SENTINEL ||
    v === LEGACY_NO_SPEECH_GARBLED ||
    v.startsWith(LEGACY_NO_SPEECH_GARBLED)
  );
}

export function getTranscriptLinesForDisplay(
  recordingTranscription: string
): string[] {
  if (recordingTranscription === NO_TRANSCRIPTION_MESSAGE) {
    return [NO_TRANSCRIPTION_MESSAGE];
  }
  if (isNoSpeechTranscriptText(recordingTranscription)) {
    return [NO_SPEECH_DETECTED_TRANSCRIPT_MESSAGE];
  }
  return transcriptFormatter.transcriptSplitter(recordingTranscription);
}

/** `[Name] (MM:SS): spoken text` */
const LINE_WITH_TIMESTAMP = /^\[(.*?)\] \((.*?)\): (.*)$/;

/** `[Name]: spoken text` (timestamp optional in newer transcripts) */
const LINE_WITHOUT_TIMESTAMP = /^\[(.*?)\]: (.*)$/;

export interface TranscriptionLineTags {
  name: string | undefined;
  time: string | undefined;
  text: string | undefined;
}

export function getTranscriptionLineTags(line: string): TranscriptionLineTags {
  const withTimestamp = line.match(LINE_WITH_TIMESTAMP);
  if (withTimestamp) {
    return {
      name: withTimestamp[1],
      time: withTimestamp[2],
      text: withTimestamp[3],
    };
  }

  const withoutTimestamp = line.match(LINE_WITHOUT_TIMESTAMP);
  if (withoutTimestamp) {
    return {
      name: withoutTimestamp[1],
      time: undefined,
      text: withoutTimestamp[2],
    };
  }

  return { name: undefined, time: undefined, text: line };
}
